import { styled } from 'styled-components';

import { colors } from '#/theme/theme';

import { LegacyButtonWithStyles } from './LegacyButtonWithStyles';

/**
 * @deprecated use <Button> instead
 */
export const LegacyBorderlessButton = styled(LegacyButtonWithStyles)`
  color: ${colors.lightContentGrey};
  background-color: transparent;
  border-radius: 0;
`;
